import { render } from "./CompanyModal.vue?vue&type=template&id=335abe48"
import script from "./CompanyModal.vue?vue&type=script&lang=js"
export * from "./CompanyModal.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__